<div
  *ngIf="errorService.error$ | async as err"
  class="w-full bg-red-600 text-white px-4 py-3 mt-4 rounded-md"
>
  <div class="flex items-center justify-between">
    <span class="font-semibold text-sm">Submission Error</span>
    <button class="text-white text-lg leading-none px-2 hover:text-gray-200" (click)="close()">
      X
    </button>
  </div>

  <div class="flex items-center gap-2 mt-1">
    <span class="border border-white rounded-full px-2 py-0.5 font-bold text-sm leading-none">
      !
    </span>
    <span class="text-sm">
      Something went wrong processing your request.
    </span>
  </div>

  <button
    class="underline text-xs mt-2 text-white hover:text-gray-200"
    (click)="toggleDetails()"
  >
    {{ showDetails ? 'Hide details' : 'Show technical details' }}
  </button>

  <pre *ngIf="showDetails" class="mt-2 text-xs bg-red-700 p-2 rounded max-h-40 overflow-auto">
{{ err }}
  </pre>
</div>
